import App from './App';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpApi from 'i18next-http-backend';
import { store } from "./redux/store";
import i18next from "i18next";
import { useSelector } from 'react-redux';
import { getApiUrl } from './utils/apiUrls';
import { useSearchParams } from 'react-router-dom';

i18next
    .use(LanguageDetector)
    .use(initReactI18next).init({
        load: 'languageOnly',
        fallbackLng: "en",
        debug: false,
        lng: "en",
        react: {
            useSuspense: false,
        },
        // backend: {
        //     allowMultiLoading: true,
        //     loadPath: 'http://localhost:3004/api/v1/language?id={{lng}}', // Adjust the API endpoint
        //     // loadPath: '', // Adjust the API endpoint
        //     // loadPath: (langs, namespace) => {
        //     //     const envState = store.getState().env;
        //     //     console.log("envState 1", !!envState, langs);
        //     //     return !!envState ? `http://localhost:3004/api/v1/language?id=${langs[0]}` : null
                
        //     // },
        //     // reloadInterval: 6000,
        // },

        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",

        // keySeparator: false, // we use content as keys

        // interpolation: {
        //   escapeValue: false
        // }
    })


export const InitI18Comp = () => {
   const envState = useSelector(state => state.env);
   const appSettings = useSelector(state => state.appSettings);
   const urlParams = new URLSearchParams(window.location.search);
   const getLang = urlParams.get('lang');
   const [appLoading, setAppLoading] = React.useState(true);

   React.useEffect(() => {
    if(!!envState) {
        i18next.use(HttpApi).init({
            load: 'languageOnly',
            fallbackLng: !!getLang ? getLang : !!appSettings?.lang ? appSettings?.lang : "en",
            debug: false,
            lng: !!getLang ? getLang : !!appSettings?.lang ? appSettings?.lang : "en",
            react: {
                useSuspense: false,
            },
            backend: {
                allowMultiLoading: true, 
                // loadPath: `http://localhost:3004/api/v1/language?id={{lng}}`,
                loadPath: `${getApiUrl('getTranslatedKeys')}/{{lng}}`, // Adjust the API endpoint
            },
            ns: ["translations"],
            defaultNS: "translations",
        });

        i18next.store.on('added', function(lng, ns) { 
            setAppLoading(false)
        })

    }
   }, [envState]);

    return(
        !!envState && !appLoading ? <I18nextProvider i18n={i18n}>
            <App />
        </I18nextProvider> : null
    )

}

export default i18n;